import React, {useMemo} from "react";

// Component
import {GroupButtons} from "../../../organizationManagement/components/GroupButtons";
import {DashboardCard} from "../../../../designSystem/components/DashboardCard";
import {Typography} from "../../../../designSystem/components/Typography";
import {BeautifulTable} from "../BeautifulTable";
import {BeautifulPieChart} from "../BeautifulPieChart";

import {getGroupPathByName} from "../../model/dashboardHelpers";
import {countByAge} from "../../model/dashboardAnalytics";

type AgeCountRow = { label: string; count: number };

export const AgeSummary = ({cases, selectedGroup, onChangeSelectedGroup}) => {
  const ageCountArray = useMemo(() => {
    const groupPath = getGroupPathByName(selectedGroup)

    const filteredCases = cases.filter(c => {
      if (groupPath === '') return true;
      return (c.category === groupPath)
    });

    return countByAge(filteredCases)
  }, [selectedGroup, cases]);

  return (
    <DashboardCard>
      <Typography variant="subtitle">
        年齡區間統計
      </Typography>

      <GroupButtons
        selectedGroup={selectedGroup}
        onChangeSelectedGroup={onChangeSelectedGroup}
      />

      <BeautifulTable<AgeCountRow>
        rows={ageCountArray}
        getRowKey={(row) => row.label}
        columns={[
          {
            key: 'question',
            header: <Typography variant="body">年齡區間</Typography>,
            render: (row) => <Typography variant="body">{row.label}</Typography>,
            cellClassName: 'text-gray-800',
          },
          {
            key: 'avg',
            header: <Typography variant="body">人數</Typography>,
            align: 'right',
            headerClassName: 'text-nowrap',
            cellClassName: 'font-medium text-gray-700',
            render: (row) => <Typography variant="bodyBold">{row.count}</Typography>,
          },
        ]}
      />

      <BeautifulPieChart
        dataKey="count"
        nameKey="label"
        data={ageCountArray}
      />
    </DashboardCard>
  )
}
